export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
export const LOGIN_PAGE_NAME = process.env.REACT_APP_LOGIN_PAGE_NAME
export const LOGIN_PAGE_TAGLINE = process.env.REACT_APP_LOGIN_PAGE_TAGLINE
export const LOGIN_PAGE_LOGO = process.env.REACT_APP_LOGO